<div
  class="c-form-element-input"
  [ngClass]="{
    'is-typed': data?.length > 0,
    'is-focus': isFocus,
    'is-error': showError,
    'is-disabled': disabled,
    'c-form-element-input--has-function': displayType === 'tooltip',
    'c-form-element-input--phone': displayType === 'phone'
  }"
>
  <div class="c-form-element-input__box" [ngClass]="[borderRadius, inputBoxWidth]">
    <label class="c-form-element-input__wrap pet-info-input-label" [ngClass]="isFocus ? '' : petInfoInputUnit">
      <span class="c-form-element-input__label">
        <span class="c-form-element-input__label-text" [innerHTML]="label"></span>
        <ng-container *ngIf="required">
          <asw-indicator-required></asw-indicator-required>
        </ng-container>
      </span>
      <span class="c-form-element-input__input">
        <input
          [ngClass]="petInfoInputSize"
          #inputElement
          type="{{ type }}"
          maxlength="{{ maxlength }}"
          id="pet-input-cage-size-carry-on-input_{{ id }}"
          class="c-form-element-input__input-item"
          [(ngModel)]="data"
          [disabled]="disabled"
          placeholder="{{ placeholder }}"
          [attr.aria-invalid]="isInvalid"
          attr.aria-required="{{ required ? true : '' }}"
          attr.aria-describedby="{{ isInvalid ? 'input-' + id + '-error' : '' }}"
          (change)="changeHandle($event)"
          (blur)="onBlurHandle($event)"
          (focus)="onFocusHandle()"
        />
      </span>
    </label>
    <div *ngIf="displayType === 'tooltip'" class="c-form-element-input__tooltip">
      <div class="c-form-element-input__tooltip-wrap">
        <button
          id="pet-input-cage-size-carry-on-input-tooltip_{{ id }}"
          class="c-form-element-input__function c-form-element-input__function--hint"
          [aswTooltip]="tooltipContent"
          [tooltipTop]="18"
        >
          <span class="u-visually-hidden" [innerHTML]="'reader.helpIcon.inputText' | staticMsg"></span>
        </button>
      </div>
    </div>
    <button
      type="button"
      *ngIf="showClear"
      id="pet-input-cage-size-carry-on-input-clear_{{ id }}"
      class="c-form-element-input__clear"
      attr.aria-controls="pet-input-cage-size-carry-on-input_{{ id }}"
      [attr.aria-hidden]="!(data?.length > 0 && isFocus)"
      [tabindex]="!(data?.length > 0 && isFocus) ? '-1' : '0'"
      (click)="clearValue()"
    >
      <span class="u-visually-hidden" [innerHTML]="'reader.clearInputInformation' | staticMsg"></span>
    </button>
  </div>
</div>
